<ion-app class="camera-hide">
    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
